/**
 * /demo/lake-palace-destination — public showcase of the Lake Palace
 * Destination template with realistic sample data (same sample couple the
 * wizard/template-card previews use). No auth, no backend.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { LakePalaceDestinationExperience } from '@/src/modules/experiences/wedding/lake-palace/LakePalaceDestinationExperience';
import type { InvitationData } from '@/src/modules/templates/types';

const SAMPLE_DATE = '2027-02-14T18:30:00+05:30';

const DEMO_DATA: InvitationData = {
  id: 'demo-lake-palace-destination',
  templateId: 'lake-palace-destination',
  occasionType: 'WEDDING',
  status: 'PUBLISHED',
  eventName: 'Aarav & Mira',
  eventDate: SAMPLE_DATE,
  eventTime: '6:30 PM',
  eventVenue: 'Amrit Mahal Courtyard, Udaipur, Rajasthan',
  hostName: 'The Sharma & Mehta Families',
  customMessage:
    'Two days of celebration on the water — music under the arches, dinner on the terrace, and a palace lit just for us.',
  rsvpLink: 'https://invitecloud.in',
  customData: {
    travelNotes:
      'Nearest airport: Maharana Pratap (UDR), 30 minutes away. Lakeside stays and boat transfers will be shared with confirmed guests.',
    wedding: {
      groom: { fullName: 'Aarav Sharma' },
      bride: { fullName: 'Mira Mehta' },
      weddingEvents: [
        {
          title: 'Mehndi at the Jetty',
          date: '2027-02-13T16:00:00+05:30',
          startTime: '4:00 PM',
          venue: 'Marble Jetty Lawn',
          visible: true,
        },
        {
          title: 'Sangeet by the Water',
          date: '2027-02-13T20:00:00+05:30',
          startTime: '8:00 PM',
          venue: 'Lake Arcade Pavilion',
          visible: true,
        },
        {
          title: 'Wedding Ceremony',
          date: SAMPLE_DATE,
          startTime: '6:30 PM',
          venue: 'Amrit Mahal Courtyard',
          visible: true,
        },
        {
          title: 'Reception on the Terrace',
          date: '2027-02-14T21:00:00+05:30',
          startTime: '9:00 PM',
          venue: 'Durbar Terrace',
          visible: true,
        },
      ],
    },
  },
  isPremium: true,
};

export function LakePalaceDestinationDemo() {
  return (
    <div className="relative min-h-screen bg-[#08202f]">
      <Link
        to="/designs"
        className="fixed left-4 top-4 z-50 rounded-full border border-white/25 bg-black/35 px-4 py-2 text-xs tracking-wide text-white/85 backdrop-blur transition-colors hover:bg-black/55 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#e7c98a]"
      >
        ← Back to designs
      </Link>
      <LakePalaceDestinationExperience data={DEMO_DATA} />
    </div>
  );
}

export default LakePalaceDestinationDemo;
